import { COUNTRY_PHONE_CODES } from '@/constants/countryCodes';
import { PHONE_PATTERNS_BY_COUNTRY_CODE } from '@/constants/patterns';

import { getTranslatedMessage } from '@/i18n/utils';

import { AppConfigurations } from '@/types/app-configurations';
import { Tenant } from '@/types/common';

type OverridePhoneNumberSchema =
  | AppConfigurations['overridePhoneNumberSchema']
  | undefined;

export const getPhoneRules = (
  selectedCountryCode: string,
  schema?: OverridePhoneNumberSchema,
) => {
  const patternMap: Record<string, string> = {
    '1-US': PHONE_PATTERNS_BY_COUNTRY_CODE.US,
    '1-Canada': PHONE_PATTERNS_BY_COUNTRY_CODE.CANADA,
    '1-Jamaica': PHONE_PATTERNS_BY_COUNTRY_CODE.JAMAICA,
    '44-UK': PHONE_PATTERNS_BY_COUNTRY_CODE.UK,
    '63-Philippines': PHONE_PATTERNS_BY_COUNTRY_CODE.PHILIPPINES,
  };
  const pattern =
    schema?.[selectedCountryCode]?.pattern ||
    patternMap[selectedCountryCode] ||
    PHONE_PATTERNS_BY_COUNTRY_CODE.DEFAULT;
  return {
    required: getTranslatedMessage('phone.form.tel.errors.required'),
    pattern: {
      value: new RegExp(pattern),
      message: getTranslatedMessage('phone.form.tel.errors.pattern'),
    },
  };
};

export function getPhoneCode(tenant: string | Tenant): string {
  return COUNTRY_PHONE_CODES[tenant as Tenant];
}

export const getOptionalPhoneValidation =
  (getCountryCode: () => string, schema?: OverridePhoneNumberSchema) =>
  (value: string | null | undefined) => {
    if (!value) return true;
    const { pattern } = getPhoneRules(getCountryCode(), schema);

    return pattern.value.test(value) ? true : pattern.message;
  };

export const getPhoneNumberMaxLengths = (
  schema?: OverridePhoneNumberSchema,
): Record<string, number> =>
  Object.fromEntries(
    Object.entries(schema ?? {}).flatMap(([code, entry]) =>
      typeof entry.maxLength === 'number' ? [[code, entry.maxLength]] : [],
    ),
  );
